import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { iconList } from '../../../../icons.config';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconList: string[];

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconList = iconList;
  }

  get icons(): string[] {
    return this.iconList;
  }

  // use this if you need to check whether an icon exists
  hasIcon(icon: string): boolean {
    return this.icons.includes(icon) || false;
  }

  registerIcons(): void {
    this.iconList.forEach((icon) => {
      const iconUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `/assets/icons/${icon}.svg`,
      );
      this.iconRegistry.addSvgIcon(icon, iconUrl);
    });
  }
}
